"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENomeCobranca = exports.ELancaTarifa = exports.EBancos = void 0;
var EBancos;
(function (EBancos) {
    EBancos["000 Controle Interno do Col\u00E9gio"] = "000";
    EBancos["061 Banco ABB S.A."] = "061";
    EBancos["246 Banco ABC Brasil S.A."] = "246";
    EBancos["356 Banco ABN AMRO S.A."] = "356";
    EBancos["275 Ban ABN AMRO Real S.A."] = "275";
    EBancos["222 Banco AGF Braseg S.A."] = "222";
    EBancos["217 Ban Agroinvest S.A."] = "217";
    EBancos["025 Banco Alfa S.A."] = "025";
    EBancos["215 Banco Am\u00E9rica do Sul S.A."] = "215";
    EBancos["213 Banco Arbi S.A."] = "213";
    EBancos["230 Banco Bandeirantes S.A."] = "230";
    EBancos["029 Banco Banerj S.A."] = "029";
    EBancos["752 Banco Banque Nationale de Paris Brasil S.A. "] = "752";
    EBancos["740 Banco Barclays e Gal\u00EDcia S.A."] = "740";
    EBancos["184 Banco BBA - CREDITANSTALT S.A."] = "184";
    EBancos["107 Banco BBM S.A."] = "107";
    EBancos["048 Banco Bemge S.A."] = "048";
    EBancos["739 Banco BGN S.A."] = "739";
    EBancos["641 Banco Bilbao Vizcaya Argentaria Brasil S.A. "] = "641";
    EBancos["394 Banco BMC S.A.V"] = "394";
    EBancos["318 Banco BMG S.A."] = "318";
    EBancos["116 Banco BNL do Brasil S.A."] = "116";
    EBancos["248 Banco Boa Vista Interatl\u00E2ntico S.A."] = "248";
    EBancos["262 Banco Boreal S.A."] = "262";
    EBancos["351 Banco Bozano Simonsen S.A."] = "351";
    EBancos["237 Banco Bradesco S.A."] = "237";
    EBancos["225 Banco Brascan S.A."] = "225";
    EBancos["044 Banco BVA S.A."] = "044";
    EBancos["062 Banco1.Net S.A."] = "062";
    EBancos["479 BankBoston Banco M\u00FAltiplo S.A."] = "479";
    EBancos["744 BankBoston N.A."] = "744";
    EBancos["218 BBS - Banco Bonsucesso S.A."] = "218";
    EBancos["749 BR Banco Mercantil S.A."] = "749";
    EBancos["070 BRB - Banco de Bras\u00EDlia S.A."] = "070";
    EBancos["263 Banco Cacique S.A."] = "263";
    EBancos["412 Banco Capital S.A."] = "412";
    EBancos["040 Banco Cargill S.A."] = "040";
    EBancos["168 Banco CCF Brasil S.A."] = "168";
    EBancos["085 Banco AILOS"] = "085";
    EBancos["266 Banco C\u00E9dula S.A."] = "266";
    EBancos["002 Banco Central do Brasil"] = "002";
    EBancos["376 Banco Chase Manhattan S.A."] = "376";
    EBancos["244 Banco Cidade S.A."] = "244";
    EBancos["745 Banco Citibank S.A."] = "745";
    EBancos["241 Banco Cl\u00E1ssico S.A."] = "241";
    EBancos["753 Banco Comercial Uruguai S.A."] = "753";
    EBancos["756 Banco Cooperativo do Brasil S.A."] = "756";
    EBancos["748 Banco Cooperativo Sicredi S.A. - BANSICREDI "] = "748";
    EBancos["721 Banco Credibel S.A."] = "721";
    EBancos["229 Banco Cruzeiro do Sul S.A."] = "229";
    EBancos["104 Caixa Econ\u00F4mica Federal"] = "104";
    EBancos["477 Citibank N.A."] = "477";
    EBancos["175 Continental Banco S.A."] = "175";
    EBancos["109 Credibanco S.A."] = "109";
    EBancos["003 Banco da Amaz\u00F4nia S.A."] = "003";
    EBancos["733 Banco das Na\u00E7\u00F5es S.A."] = "733";
    EBancos["707 Banco Daycoval S.A."] = "707";
    EBancos["219 Banco de Cr\u00E9dito de S\u00E3o Paulo S.A."] = "219";
    EBancos["291 Banco de Cr\u00E9dito Nacional S.A."] = "291";
    EBancos["240 Banco de Cr\u00E9dito Real de Minas Gerais S.A.  "] = "240";
    EBancos["300 Banco de La Nacion Argentina"] = "300";
    EBancos["495 Banco de La Provincia de Buenos Aires"] = "495";
    EBancos["494 Banco de La Republica Oriental del Uruguay"] = "494";
    EBancos["456 Banco de Tokyo-Mitsubishi Brasil S.A."] = "456";
    EBancos["214 Banco Dibens S.A."] = "214";
    EBancos["001 Banco do Brasil S.A."] = "001";
    EBancos["028 Banco do Estado da Bahia S.A"] = "028";
    EBancos["031 Banco do Estado de Goi\u00E1s S.A."] = "031";
    EBancos["024 Banco de Pernambuco S.A."] = "024";
    EBancos["027 Banco do Estado de Santa Catarina S.A."] = "027";
    EBancos["033 Banco Santander (Banespa)"] = "033";
    EBancos["047 Banco do Estado de Sergipe S.A."] = "047";
    EBancos["034 Banco do Estado do Amazonas S.A."] = "034";
    EBancos["035 Banco do Estado do Cear\u00E1 S.A."] = "035";
    EBancos["021 Banco do Estado do Esp\u00EDrito Santo S.A."] = "021";
    EBancos["036 Banco do Estado do Maranh\u00E3o S.A."] = "036";
    EBancos["037 Banco do Estado do Par\u00E1 S.A."] = "037";
    EBancos["038 Banco do Estado do Paran\u00E1 S.A."] = "038";
    EBancos["039 Banco do Estado do Piau\u00ED S.A."] = "039";
    EBancos["041 Banco do Estado do Rio Grande do Sul S.A."] = "041";
    EBancos["004 Banco do Nordeste do Brasil S.A."] = "004";
    EBancos["487 Deutsche Bank S.A. - Banco Alem\u00E3o"] = "487";
    EBancos["210 Dresdner Bank Lateinamerika Aktiengesellsc"] = "210";
    EBancos["751 Dresdner Bank Lateinamerika - Brasil S.A."] = "751";
    EBancos["743 Banco Emblema S.A."] = "743";
    EBancos["242 Banco Euroinvest S.A. - Eurobanco"] = "242";
    EBancos["370 Banco Europeu para a America Latina S.A."] = "370";
    EBancos["265 Banco Fator S.A."] = "265";
    EBancos["224 Banco Fibra S.A."] = "224";
    EBancos["200 Banco Ficrisa Axelrud S.A."] = "200";
    EBancos["626 Banco Ficsa S.A."] = "626";
    EBancos["473 Banco Finan. Port./Em absor\u00E7\u00E3o"] = "473";
    EBancos["199 Banco Financial Portugu\u00EAs S.A."] = "199";
    EBancos["725 Banco Finansinos S.A."] = "725";
    EBancos["252 Banco Fininvest S.A."] = "252";
    EBancos["221 Banco Fleming Graphus S.A."] = "221";
    EBancos["346 Banco Franc\u00EAs e Brasileiro S.A."] = "346";
    EBancos["489 Banco Franc\u00EAs Internacional - Brasil S.A."] = "489";
    EBancos["505 Banco Garantia S.A."] = "505";
    EBancos["233 Banco GE Capital S.A."] = "233";
    EBancos["734 Banco Gerdau S.A."] = "734";
    EBancos["612 Banco Guanabara S.A."] = "612";
    EBancos["064 Goldman Sachs do Brasil Banco M\u00FAltiplo S.A."] = "064";
    EBancos["399 HSBC Bank Brasil S.A. - Banco M\u00FAltiplo"] = "399";
    EBancos["063 Banco Ibibank S.A. Banco M\u00FAltiplo"] = "063";
    EBancos["228 Banco Icatu S.A."] = "228";
    EBancos["258 Banco Induscred S.A."] = "258";
    EBancos["604 Banco Industrial do Brasil S.A."] = "604";
    EBancos["320 Banco Industrial e Comercial S.A."] = "320";
    EBancos["653 Banco Indusval S.A."] = "653";
    EBancos["630 Banco Intercap S.A."] = "630";
    EBancos["249 Banco Investcred S.A."] = "249";
    EBancos["341 Banco Ita\u00FA S.A."] = "341";
    EBancos["492 ING Bank N.V."] = "492";
    EBancos["042 Banco J. Safra S.A."] = "042";
    EBancos["383 Banco Juno"] = "383";
    EBancos["757 Banco KEB do Brasil S.A."] = "757";
    EBancos["235 Banco Liberal S.A."] = "235";
    EBancos["600 Banco Luso Brasileiro S.A."] = "600";
    EBancos["472 Lloyds Bank PLC."] = "472";
    EBancos["204 Banco Mantrust SRL S.A."] = "204";
    EBancos["212 Banco Matone S.A."] = "212";
    EBancos["720 Banco Maxinvest S.A."] = "720";
    EBancos["392 Banco Mercantil Finasa S.A."] = "392";
    EBancos["389 Banco Mercantil do Brasil S.A."] = "389";
    EBancos["008 Banco Santander(Meridional de Brasil S.A.)"] = "008";
    EBancos["755 Banco Merrill Lynch S.A."] = "755";
    EBancos["746 Banco Modal S.A."] = "746";
    EBancos["738 Banco Morada S.A."] = "738";
    EBancos["488 Morgan Guaranty Trust Company of New York"] = "488";
    EBancos["148 Multi-Banco S.A."] = "148";
    EBancos["007 Banco Nacional de Desenvol. Econ\u00F4mico Social"] = "007";
    EBancos["151 Nossa Caixa - Nosso Banco S.A."] = "151";
    EBancos["045 Banco Opportunity S.A."] = "045";
    EBancos["208 Banco Pactual S.A."] = "208";
    EBancos["623 Banco Panamericano S.A."] = "623";
    EBancos["611 Banco Paulista S.A."] = "611";
    EBancos["650 Banco Pebb S.A."] = "650";
    EBancos["613 Banco Pec\u00FAnia S.A."] = "613";
    EBancos["643 Banco Pine S.A."] = "643";
    EBancos["658 Banco Porto Real S.A."] = "658";
    EBancos["735 Banco Pottencial S.A."] = "735";
    EBancos["719 Banco Primus S.A."] = "719";
    EBancos["638 Banco Prosper S.A."] = "638";
    EBancos["030 PARAIBAN - Banco do Estado da Para\u00EDba S.A."] = "030";
    EBancos["254 Paran\u00E1 Banco S.A."] = "254";
    EBancos["747 Banco Rabobank International Brasil S.A."] = "747";
    EBancos["216 Banco Regional Malcon S.A."] = "216";
    EBancos["633 Banco Rendimento S.A."] = "633";
    EBancos["750 Banco Republic National of New York S.A."] = "750";
    EBancos["741 Banco Ribeir\u00E3o Preto S.A."] = "741";
    EBancos["453 Banco Rural S.A."] = "453";
    EBancos["422 Banco Safra S.A."] = "422";
    EBancos["353 Banco Santander Brasil S.A."] = "353";
    EBancos["502 Banco Santander de Neg\u00F3cios S.A."] = "502";
    EBancos["424 Banco Santander Noroeste S.A./Em absor\u00E7\u00E3o"] = "424";
    EBancos["607 Banco Santos Neves S.A."] = "607";
    EBancos["702 Banco Santos S.A."] = "702";
    EBancos["250 Banco Schahin Cury S.A."] = "250";
    EBancos["211 Banco Sistema S.A."] = "211";
    EBancos["637 Banco Sofisa S.A."] = "637";
    EBancos["366 Banco Sogeral S.A."] = "366";
    EBancos["243 Banco Stock S.A."] = "243";
    EBancos["347 Banco Sudameris do Brasil S.A."] = "347";
    EBancos["205 Banco Sul Am\u00E9rica S.A."] = "205";
    EBancos["464 Banco Sumitomo Brasileiro S.A."] = "464";
    EBancos["618 Banco Tend\u00EAncia S.A."] = "618";
    EBancos["737 Banco Theca S.A."] = "737";
    EBancos["634 Banco Tri\u00E2ngulo S.A."] = "634";
    EBancos["084 Uniprime Norte do Paran\u00E1"] = "084";
    EBancos["099 Uniprime Central"] = "099";
    EBancos["133 Cresol"] = "133";
    EBancos["136 Unicred"] = "136";
    EBancos["493 Banco Union - Brasil S.A."] = "493";
    EBancos["496 Banco UNO-E Brasil S.A."] = "496";
    EBancos["409 UNIBANCO - Uni\u00E3o de Bancos Brasileiros S.A."] = "409";
    EBancos["247 Banco UBS Warburg S.A."] = "247";
    EBancos["655 Banco Votorantim S.A."] = "655";
    EBancos["610 Banco VR S.A."] = "610";
    EBancos["480 Banco Wachovia S.A."] = "480";
    EBancos["997 Factus"] = "997";
    EBancos["999 Outro Banco"] = "999";
})(EBancos = exports.EBancos || (exports.EBancos = {}));
var ELancaTarifa;
(function (ELancaTarifa) {
    ELancaTarifa["Lan\u00E7ar Tarifa"] = "0";
    ELancaTarifa["N\u00E3o Lan\u00E7ar Tarifa"] = "2";
})(ELancaTarifa = exports.ELancaTarifa || (exports.ELancaTarifa = {}));
var ENomeCobranca;
(function (ENomeCobranca) {
    ENomeCobranca["Respons\u00E1vel"] = "R";
    ENomeCobranca["Aluno"] = "A";
    ENomeCobranca["Ambos"] = "2";
})(ENomeCobranca = exports.ENomeCobranca || (exports.ENomeCobranca = {}));
